import React from "react";
import { Container } from "react-bootstrap";
import "./privicypolicy.css";

const PolicyContent = () => {
  return (
    <section className="privacy-policy-content cms-pages-content-wraper mb-5">
      <Container className="theme-container">
        <h6 className="mb-3 fs-6">Effective Date: January 1, 2025</h6>
        <p>
          5 Star Grading LLC (“we,” “us,” or “our”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or communicate with us.
        </p>

        <h5 className="mt-xl-4 mt-lg-3 mt-2 fs-6">1. Information We Collect</h5>
        <p>We may collect the following information when you fill out a form, request a quote, or contact us:</p>
        <ul className="content-list ms-4">
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Project details or service inquiries</li>
          <li>Company name (if applicable)</li>
          <li>IP address and browser information (for analytics purposes)</li>
        </ul>

        <h5 className="mt-xl-4 mt-lg-3 mt-2 fs-6">2. How We Use Your Information</h5>
        <p>Your information is used for the following purposes:</p>
        <ul className="content-list ms-4">
          <li>To respond to inquiries and provide estimates or project information</li>
          <li>To follow up on service requests or ongoing projects</li>
          <li>To improve our website and customer service</li>
          <li><strong>To comply with any legal obligations</strong></li>
        </ul>

        <h5 className="mt-xl-4 mt-lg-3 mt-2 fs-6">3. Sharing of Information</h5>
        <p>
          We do not sell, rent, or trade your personal information. We may share your information with trusted third-party service providers who help us operate our business or website, but only to the extent necessary.
        </p>
        <p>
          We may disclose personal information if required to do so by law or in good faith belief that such action is necessary to:
        </p>
        <ul className="content-list ms-4">
          <li>Comply with legal obligations</li>
          <li>Protect and defend our rights or property</li>
          <li>Prevent fraud or abuse</li>
        </ul>

        <h5 className="mt-xl-4 mt-lg-3 mt-2 fs-6">4. Cookies and Tracking</h5>
        <p>
          Our website may use cookies or similar technologies to enhance your browsing experience and analyze web traffic. You can choose to disable cookies through your browser settings, though this may affect functionality.
        </p>

        <h5 className="mt-xl-4 mt-
        -3 mt-2 fs-6">5. Data Security</h5>
        <p>
          We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet or method of electronic storage is 100% secure.
        </p>

        <h5 className="mt-xl-4 mt-lg-3 mt-2 fs-6">6. Your Rights and Choices</h5>
        <p>
          You may request access to, correction of, or deletion of your personal data by contacting us at the email below. We will respond in a reasonable timeframe, in accordance with applicable laws.
        </p>

        <h5 className="mt-xl-4 mt-lg-3 mt-2 fs-6">7. Third-Party Links</h5>
        <p>
          Our website may contain links to other websites. We are not responsible for the privacy practices or content of those third-party sites.
        </p>

        <h5 className="mt-xl-4 mt-lg-3 mt-2 fs-6">8. Children’s Privacy</h5>
        <p>
          Our services are not directed to individuals under the age of 13, and we do not knowingly collect personal information from children.
        </p>

        <h5 className="mt-xl-4 mt-lg-3 mt-2 fs-6">9. Changes to This Policy</h5>
        <p>
          We reserve the right to update this Privacy Policy at any time. Changes will be posted on this page with an updated effective date.
        </p>
      </Container>
    </section>
  );
};

export default PolicyContent;
